import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import kzTranslation from './locales/kz/translation.json';
import ruTranslation from './locales/ru/translation.json';

const getLanguageFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  
  if (['ru', 'kk', 'en'].includes(langParam)) {
    localStorage.setItem('preferredLanguage', langParam);
    return langParam;
  }
  
  return localStorage.getItem('preferredLanguage') || 'ru';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      kk: {
        translation: kzTranslation
      },
      ru: {
        translation: ruTranslation
      }
    },
    lng: getLanguageFromURL(),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;